import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const Ctx = createContext(null);
export const useFeed = () => useContext(Ctx);
const POLL_MS = 30000;

export function FeedProvider({ children, enabled }) {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [lastAt, setLastAt] = useState(null);
  const [seenAt, setSeenAt] = useState("");
  const latest = useRef(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/admin/feed");
      const fresh = r.data.items;
      setSeenAt((s) => s || r.data.seen_at || "");
      if (latest.current && fresh.length) {
        const news = fresh.filter((i) => i.at > latest.current && i.actor === "client");
        news.slice(0, 3).forEach((i) => toast(`${i.ref} · ${i.who}`, { description: i.action, duration: 8000 }));
        if (news.length && document.hidden && "Notification" in window && Notification.permission === "granted") {
          new Notification("Atelier KOUOH", { body: `${news.length} nouveauté(s) : ${news[0].ref} — ${news[0].action}` });
        }
      }
      latest.current = fresh[0]?.at || latest.current || r.data.now;
      setItems(fresh); setUnread(r.data.unread); setLastAt(r.data.now);
    } catch { /* keep previous feed */ }
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    const id = setInterval(refresh, POLL_MS);
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, [enabled, refresh]);

  useEffect(() => { document.title = unread ? `(${unread}) KOUOH — Administration` : "KOUOH — Administration"; }, [unread]);

  const markSeen = useCallback(async () => { if (!unread) return; setUnread(0); try { await api.post("/admin/feed/seen"); } catch { /* ignore */ } }, [unread]);
  const askPermission = () => { if ("Notification" in window && Notification.permission === "default") Notification.requestPermission(); };
  return <Ctx.Provider value={{ items, unread, lastAt, seenAt, refresh, markSeen, askPermission }}>{children}</Ctx.Provider>;
}
